import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable} from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { ApiConnectorService } from '../__api/api-connector.service';
import { GuiFlowService } from '../__gui/gui-flow.service';
import { FunctionsService } from '../__common/functions.service';
import { ResolverService } from '../__common/resolver.service';
import { TermsPolicyService } from '../terms-policy.service';
import { Router } from '@angular/router';
import { ConfigService } from '../___common/__config/config.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private readonly authUrl = 'your-auth-endpoint'; // Replace with your backend endpoint
  loading = false;
  
  private loggedIn = new BehaviorSubject<boolean>(false);
  private userId: number | null = null;

  constructor(private http: HttpClient,private guiFlow: GuiFlowService,private apiConnector: ApiConnectorService,private commonFunctions: FunctionsService,private router: Router,private resolver: ResolverService,private termsAndPolicyService: TermsPolicyService,private configService: ConfigService) {}

  getLoading(){
    return this.loading;
  }

  setIsLoading(value){
    return this.loading = value;
  }
  
  loginPost(email: string, password: string): Observable<any> {
    return this.http.post<any>(`${this.authUrl}/login`, { email, password }).pipe(
      tap(response => {
        document.cookie = `authToken=${response.token}; path=/`;
      })
    );
  }

  tryLogin(loginObj){
    switch(loginObj.path){
      case 'login-webapp':
        this.attemptLogin(loginObj);
        break;
      case 'cookiesAppLogin':
        let voyjaleasSessionToken = this.getCookie('voyjaleasSessionToken');
        let voyjaleasSessionUsername = this.getCookie('voyjaleasSessionUsername');
        //check username and set the currentClientId global variable (for GET)
        if(loginObj.token && voyjaleasSessionToken && voyjaleasSessionUsername){
          if(voyjaleasSessionUsername == loginObj.username){
            this.validateCookies(loginObj,voyjaleasSessionToken,voyjaleasSessionUsername);
          }else{
            this.loading = false;
            console.log('*** ERROR: Not able to login via cookies>>');
          }
        }else{
          this.loading = false;
          console.log('*** ERROR: Not able to login via cookies>>');
        }
        break;
      case 'check-token':
        this.loading = true;
        break;
      default:
        this.loading = false;
        //this.guiFlow.showNotificationMessage('Datos incorrectos');
        console.log('Not able to login >>');
        return false;
    }
  }

  attemptLogin(loginObj) {
    
    this.loading = true;
    this.login(loginObj.username, loginObj.password).subscribe(
      response => {
        this.loading = false;
        if (response.user_id) {
          //GET
          this.resolver.getBackendDataForQueryId('getThisClientApps',true,response.user_id);
          this.resolver.getBackendDataForQueryId('clientChecklists',true,response.user_id);
          this.resolver.getBackendDataForQueryId('getClientTools',true,response.user_id);
      
          this.router.navigate(['/home']); // Redirect after login
        } else {
          this.loading = false;
          console.log('Invalid login credentials');
        }
      },
      error => {
        this.loading = false;
        console.log('FRONT: Login failed');
        this.guiFlow.openSimpleSnackBar(error.error.error,null,null);
      }
    );
  }

  validateLinkToken(url){
    this.loading = true;
    return this.http.get(url);
  }
    //const data = await this.getXhr(url).toPromise();
  getXhr(url){
    return this.http.get(url)
    //return this.http.get(url, { params }); // Returns an Observable
  }

  saveAcceptedTerms(response,loginObj){
    this.termsAndPolicyService.insertTermsAndPolicyAccepted(response).subscribe({
      next: (result: any) => {
        if (Array.isArray(result)) {
          const [res1, res2] = result;
          this.afterPromisesResolved(res1, res2,response,loginObj);
        } else {
          this.afterPromisesResolved(result, null,response,loginObj);
        }
        /* this.loading = false; */
      },
      error: (err) => {
 /*        console.error('Error in request:', err);
        this.loading = false;
        this.guiFlow.openSimpleSnackBar('Error', 'error', null, null); */
      }
    });
  }

  afterPromisesResolved(r1,r2,response,loginObj){
    this.processPasswordCreated(response,loginObj);
  }
  
  saveNewPass(loginObj){
    this.loading = true;
    this.register(loginObj.username,loginObj.password,loginObj.token).subscribe(
      (response) => {
          this.loading = false;
          this.saveAcceptedTerms(response,loginObj);  
        },
      (error) => {
          if(error && error.error){
            this.guiFlow.reportError(error.error.error,'');
          }else{
            console.log('Error on register:'+error);
            this.guiFlow.reportError('Error: contacta con un administrador','');
          }
          this.loading = false;
        }
      );
  }

  processPasswordCreated(res,obj){
    if(res){
      if(res.success){
        this.saveConfigData(res,obj);
        obj.role = 'user';
        this.reroute(obj,obj.role);
        res.role? null : console.log('[WARNING]: No role associated to user.')
      }else
      if(res.KO){
        this.guiFlow.openSimpleSnackBar('Los datos son incorrectos.','error',null,null);
      }else{
        this.guiFlow.openSimpleSnackBar('Error en el servidor','error',null,null);
      }
    }else{
      this.guiFlow.openSimpleSnackBar('Los datos son incorrectos.','error',null,null);
    }
  }

  updatePassword(loginObj){
    this.loading = true;
    this.updateUserPassword(loginObj.username,loginObj.password,loginObj.token).subscribe(
      (response) => {
          this.loading = false;
          this.guiFlow.openSimpleSnackBar('Password actualizado', 'success');
          this.processPasswordCreated(response,loginObj);
        },
      (error) => {
          if(error && error.error){
            this.guiFlow.reportError(error.error.error,'');
          }else{
            console.log('Error on register:'+error);
            this.guiFlow.reportError('Error: contacta con un administrador','');
          }
          this.loading = false;
        }
      );
  }

  updateUserPassword(email: string, password: string,tokenPass: string): Observable<any> {
    return this.http.post<any>(this.configService.getApiUrlRefactor('auth')+'reset_password.php', {email, password,tokenPass}, { withCredentials: true })
      .pipe(
        map(response => {
          if (response.success && response.user_id) {
            this.loggedIn.next(true);
            this.userId = response.user_id;
            this.commonFunctions.setSelectedClientId(this.userId);
          }
          return response;
        })
      );
  }


  generateNewLink(loginObj){
    this.apiConnector.generateNewLink(loginObj).subscribe({
      next: (res) => this.processLinkGenerated(res, loginObj),
      error: (err) => this.handleLoginError(err), // Handle errors here
      })
  }

  processLinkGenerated(res, loginObj){
    console.log(res);
  }
  

  handleLoginError(error: any) {
    this.loading = false;
    console.error('ERROR: Login failed. ->', error);
    this.guiFlow.openSimpleSnackBar('Error, please contact administrator','error',null,null);
  }

  processIsUserLoggedIn(res,obj){
    this.loading = false;
    if(res){
      if(res.OK){
        /* this.initService.initWebapp() */
        this.saveConfigData(res,obj);
        res.role? this.reroute(obj,res.role) : this.reroute(obj,'user');
        res.role? null : console.log('[WARNING]: No role associated to user.')
      }else
      if(res.KO){
        // Account does not exist. REGISTER!
        if(res.code == '2'){
          this.guiFlow.openSimpleSnackBar(res.message,'info',null,'Register');
        }
        // Invalid credentials
        if(res.code == '3'){
          this.guiFlow.openSimpleSnackBar(res.message,'error',null,null);
        }
      }else{
        this.guiFlow.openSimpleSnackBar('Error por favor contacta con el admin.','error',null);
      }
    }else{
      this.guiFlow.openSimpleSnackBar('Los datos son incorrectos.','error',null,null);
    }
  }

  saveConfigData(res,obj){
    let log = { username: obj.username,operation: 'login'};
    /* this.apiLogin.postUserSessionLog('post','sessionLog',log).subscribe(res => this.savedLog(res)); */
    let historic = {
      operation: 'login to dashboard',
      previousObj: JSON.stringify({}),
      newObj: JSON.stringify('this.sessionData'),
      FK_ID_clientDetails: 'this.sessionData.id'
    };
    /* this.apiConnector.createHistoric(historic,'loginpost'); */
    this.saveCookie('voyjaleasSessionToken',res.token,1);
    this.saveCookie('voyjaleasSessionUsername',obj.username,1);
  }

  validateCookies(loginObj,tokenCookie,usernameCookie){
    this.apiConnector.login('cookiesAppLogin',usernameCookie,null,tokenCookie).subscribe(res => this.processValidationToken(res,loginObj));
  }

  processValidationToken(response,loginObj){
    this.loading = false;
    if(response){
      if(response.OK){
        this.saveConfigCookiesData(response,loginObj);
        this.reroute(loginObj,response.role);
      }
      // DEBUG
      //response.KO? this.guiFlow.openSimpleSnackBar('ERROR: Cookie login: Los datos son incorrectos.','Ok') : this.guiFlow.openSimpleSnackBar('ERROR: Cookie login: Contacte a su administrador','Ok');
    }else{
      // DEBUG
      //this.guiFlow.openSimpleSnackBar('Error en el servidor','Ok');
    }
  }

  saveConfigCookiesData(res,obj){
    let log = { username: obj.username,operation: 'login'};
    /* this.apiLogin.postUserSessionLog('post','sessionLog',log).subscribe(res => this.savedLog(res)); */
    this.saveCookie('voyjaleasSessionToken',obj.token,1);
    this.saveCookie('voyjaleasSessionUsername',obj.username,1);
  }

  reroute(loginObj,role){  
    switch(loginObj.path){
      case 'login-webapp':
      case 'cookiesAppLogin':
      case 'account-created':
      case 'recover-password':
      case 'register':
        if(role=='user' || role=='admin'){
          this.guiFlow.goToHome();
        }else{
          console.log('ROL SIN PERMISOS');
          /* this.openSimpleSnackBar('Rol sin permisos','Ok'); */
        }
        break;
      default:
        console.log('ERROR: Error on reroute after successfull login. No loginObj.path');
        break;
    }
  }

  forgotPassword(email: string): Observable<any> {
    return this.http.post<any>(`${this.authUrl}/forgot-password`, { email });
  }

  private deleteAllCookies(): void {
    document.cookie.split(';').forEach((cookie) => {
      const name = cookie.split('=')[0].trim();
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    });
  }

  closeSessionOld(){
/*     let log = { username: this.resolver.getUserSessionData().username,operation: 'logout-webapp',FK_ID_clientDetails: this.sessionData.id};
    this.apiConnector.postUserSessionLog('post','sessionLog',log).subscribe(res => this.savedLog(res)); */
  }

  checkAuthentication(): boolean {
    const authToken = this.getCookie('authToken');
    return !!authToken;
  }

  saveCookie(cname, cvalue, exdays){
    const d = new Date();
      d.setTime(d.getTime() + (exdays*24*60*60*1000));
      let expires = "expires="+ d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  delete_cookie(name) {
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }

  getCookie(name: string): string | null {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  checkForCookies(route){
    switch(route){
      case 'dashboard':
        if(this.getCookie('voyjaleasSessionToken') && this.getCookie('voyjaleasSessionUsername')){
          return true;
        }else{
          return false;
        }
      case 'login-webapp':
        if(this.getCookie('voyjaleasSessionToken') && this.getCookie('voyjaleasSessionUsername')){
         return true;
        }else{
          return false;
        }
      default:
        break;
      }
  }


  login(email: string, password: string): Observable<any> {
    return this.http.post<any>(this.configService.getApiUrlRefactor('auth')+'login.php', { email, password }, { withCredentials: true } ) /*  */
      .pipe(
        map(response => {
          if (response.user_id) {
            this.loggedIn.next(true);
            this.userId = response.user_id;
            this.commonFunctions.setSelectedClientId(this.userId);
          }
          return response;
        })
      );
  }

  checkSession(): Observable<any> {
    return this.http.get<any>(this.configService.getApiUrlRefactor('auth')+'check_session.php', { withCredentials: true })
      .pipe(
        map(response => {
          this.loggedIn.next(response.loggedIn);
          this.userId = response.user_id || null;
          this.commonFunctions.setSelectedClientId(this.userId);
          return response;
        })
      );
  }

  register(email: string, password: string,tokenPass: string): Observable<any> {
    return this.http.post<any>(this.configService.getApiUrlRefactor('auth')+'register.php', {email, password,tokenPass}, { withCredentials: true })
      .pipe(
        map(response => {
          if (response.success && response.user_id) {
            this.loggedIn.next(true);
            this.userId = response.user_id;
            this.commonFunctions.setSelectedClientId(this.userId);
          }
          return response;
        })
      );
  }
  

  closeSession(){
    //document.cookie = 'authToken=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
    //this.commonFunctions.setSelectedClientId(null);
    //this.deleteAllCookies();
    this.logout().subscribe(
      response => {
        this.loggedIn.value == false? this.commonFunctions.setSelectedClientId(null) : console.log('Error en close session');
        this.loading = false;
        this.router.navigate(['/loading']); // Redirect after login;
        // Clear user session (e.g., tokens)
        localStorage.removeItem('authToken');
        sessionStorage.clear();

        // Clear the resolver cache
        this.resolver.clearCache();
      }
    );
  }
  

  logout(): Observable<any> {
    return this.http.get<any>(this.configService.getApiUrlRefactor('auth')+'logout.php', { withCredentials: true })/*   */
      .pipe(
        map(response => {
            this.loggedIn.next(false);
            return response;
        })
      );
  }

  // Observable for reactive components
  isUserLoggedIn$(): Observable<boolean> {
    return this.loggedIn.asObservable();
  }

  // Getter for synchronous login state
  get isUserLoggedIn(): boolean {
    return this.loggedIn.value;
  }

}
